import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  containerr: {
    backgroundColor: "#FFF",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #D1D5DC",
    padding: "14px 10px",
    "& img": {
      width: "10%",
    },
  },
  cancelBtn: {
    padding: "0px 16px",
    borderRadius: "8px",
    border: "1px solid #D0D5DD",
    backgroundColor: "#F9FAFB",
    height: 48,
    maxWidth: 165,
    width: "100%",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    ":hover": {
      backgroundColor: "#F9FAFB",
      opacity: 0.8,
    },
  },
  reviewDocHdng: {
    fontSize: 24,
    fontWeight: 700,
    fontFamily: "Inter",
    color: "#000",
    margin: 0,
    textAlign: "center",
    flex: 1,
  },
  mainTab: {
    fontSize: 14,
    fontWeight: 500,
    fontFamily: "Inter",
    color: "#27272A",
    "&[data-active]": {
      borderColor: "#171717",
      color: "#27272A",
      "&:hover": {
        borderColor: "#171717",
        color: "#27272A",
      },
    },
    "&:hover": {
      borderColor: "#171717",
      color: "#27272A",
    },
  },
  mainTabsList: {
    borderBottom: "none",
    justifyContent: "center",
    gap: "16px",
    width: "60%",
    // height: "56px",
    padding: "25px",
    margin: "0 auto",
  },
  stepHeader: {
    display: "flex",
    padding: "24px 32px 10px 32px",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
    borderBottom: "1px solid #E5E7EB",
    background: "#F5F5F5",
  },
  planTypeHdng: {
    fontSize: 24,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#101828",
    margin: 0,
  },
  sentDate: {
    fontSize: 14,
    fontWeight: 400,
    fontFamily: "Inter",
    color: "#344054",
    margin: 0,
  },
  clientDataContainer: {
    width: "80%",
    margin: "0px auto",
    padding: "10px",
    backgroundColor: "#F9FAFB",
    border: "0.5px solid #E5E7EB",
  },
  inputStyle: {
    "& .mantine-Input-wrapper": {
      height: "auto",
      minWidth: "150px",
      backgroundColor: "#FFFFFF",
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      "& .mantine-Input-input": {
        fontFamily: "Inter",
        border: "none",
        backgroundColor: "transparent",
        padding: "10px 14px",
        height: "44px",
        fontFamily: "Inter",
        color: "#262626",
      },
      "& .mantine-Textarea-input": {
        height: 153,
        overflowY: "auto",
      },
      "& .mantine-Select-rightSection svg": {
        color: "#667085",
      },
    },
    "& .mantine-DateInput-wrapper": {
      outline: "4px solid rgb(212, 212, 212, .2)",
      "& .mantine-DateInput-icon": {
        "& svg": {
          color: "#262626",
          fontSize: 18,
        },
      },
      "& .mantine-DateInput-input": {
        paddingLeft: 36,
        fontWeight: 600,
      },
    },
    "& .mantine-InputWrapper-label": {
      color: "#262626",
      marginBottom: "6px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  sectionHdng: {
    color: "#262626",
    margin: 0,
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 700,
    textAlign: "center",
    backgroundColor: "#E5E5E5",
    padding: "5px 10px",
  },
  diagnosisBoxLabel: {
    color: "#262626",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    margin: 0,
    marginBottom: 6,
  },
  diagnosisBox: {
    borderRadius: 8,
    border: "1px solid #E5E5E5",
    backgroundColor: "#FFF",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    padding: "10px 14px",
    height: 153,
    overflowY: "auto",
  },
  diagnosisBoxItemsFlex: {
    gap: "12px",
    flexWrap: "wrap",
  },
  diagnosisBoxItem: {
    alignItems: "center",
    gap: 4,
    padding: "4px 10px",
    height: "fit-content",
    width: "fit-content",
    borderRadius: 16,
    backgroundColor: "#F2F4F7",
    "& p": {
      margin: 0,
      whiteSpace: "nowrap",
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: 500,
      color: "#344054",
    },
  },
  signatureParentBox: {
    borderRadius: 10,
    border: "2px solid #E5E7EB",
    backgroundColor: "#FFF",
    padding: "26px",
  },
  signaturesGrid: {
    margin: "40px auto",
    width: "80%",
  },
  signatureParentBoxPosition: {
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: 400,
    color: "#4A5565",
    margin: 0,
  },
  signBoxInputsRow: {
    gap: 24,
    alignItems: "flex-end",
      // display: "flex", 
      flexWrap: "wrap",
  },
  signBoxInputsStyle: {
    display: "flex",
    flex: 1,
    minWidth: "220px",
    flexDirection: "column-reverse",
    "& .mantine-Input-input": {
      borderBottom: "2px solid #FFD230",
      fontFamily: "Inter",
      padding: "8px 10px",
      height: "44px",
      fontFamily: "Inter",
      color: "#262626",
      "&:focus": {
        borderBottom: "2px solid #FFD230",
      },
    },
    "& .mantine-InputWrapper-label": {
      color: "#6A7282",
      marginTop: "4px",
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: 500,
      "& .mantine-TextInput-required": {
        color: "#FE9A00",
      },
    },
  },
  borderBottomGray: {
    "& .mantine-Input-input": {
      borderBottom: "2px solid #D1D5DC",
    },
  },
  ButtonToAddSign: {
    height: 70,
    borderBottom: "2px solid #FFD230",
    width: "100%",
    display: "flex",
    alignItems: "flex-end",
    gap: 4,
    padding: "10px",
    color: "#6A7282",
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 500,
    "& svg": {
      color: "#6A7282",
    },
  },
  signDrawBoxLabel: {
    color: "#6A7282",
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 500,
    margin: 0,
    marginTop: "4px",
    "& > span": {
      color: "#FE9A00",
      marginLeft: 4,
    },
  },
  clearBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid #D0D5DD",
    backgroundColor: "#F9FAFB",
    height: 48,
    width: "100%",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 18,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    ":hover": {
      backgroundColor: "#F9FAFB",
      opacity: 0.8,
    },
  },
  submitBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid var(--app-primary)",
    backgroundColor: "var(--app-primary)",
    height: 48,
    width: "fit-content",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 18,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "var(--app-on-primary)",
    "& .mantine-Button-label": {
      gap: 8,
    },
    ":hover": {
      backgroundColor: "var(--app-primary)",
      opacity: 0.8,
    },
  },
  greenBtnStyle: {
    backgroundColor: "#00A63E",
    borderColor: "#00A63E",
    fontSize: 14,
    fontWeight: 500,
    color: "#FFF",
    ":hover": {
      backgroundColor: "#00A63E",
      opacity: 0.8,
    },
  },
  signViewBox: {
    height: 70,
    borderBottom: "2px solid #FFD230",
    width: "100%",
    display: "flex",
    alignItems: "flex-end",
    "& img": {
      height: "100%",
    },
    "& .textSign": {
      fontFamily: "Island Moments",
      fontSize: 34,
      fontWeight: 400,
      color: "#262626",
      lineHeight: "normal",
      margin: 0,
      padding: "0px 10px",
      textAlign: "center",
      width: "100%",
    },
  },
  flex1: {
    flex: 1,
  },
  tabFooter: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 40px",
    backgroundColor: "#F5F5F5",
    borderBottom: "1px solid #E5E7EB",
    width: "100%",
  },
  navBtn: {
    color: "#262626",
    fontSize: "16px",
    fontWeight: 400,
    fontFamily: "Inter",
    "&:hover": {
      backgroundColor: "transparent",
      color: "#262626",
    },
    "&:disabled": {
      backgroundColor: "transparent",
      color: "#D1D5DB",
      cursor: "not-allowed",
    },
  },
  addSignatureWrapper: {
    maxWidth: "750px",
    width: "100%",
    margin: "0 auto",
  },
  signatureInfoRow: {
    alignItems: "flex-start",
    flexWrap: "wrap",
    width: "85%",
    gap: 10,
    marginInline: "auto",
    marginBottom: 50,
  },
  tabs: {
    width: "100%",
    fontFamily: "Inter",
  },
  tab_list: {
    background: "#EAECF0",
    borderRadius: "8px 8px 0px 0px",
    border: "none",
    justifyContent: "center",
  },
  tabPanel: {},
  tab: {
    color: "#979797 !important",
    fontFamily: "Inter",
    fontSize: 14,
    marginBottom: 0,
    padding: "20.2px 16px 20.2px 10px",
    fontWeight: 500,
    borderWidth: "2px !important",
    "& > span": {
      display: "flex",
      alignItems: "center",
      gap: 10,
    },
    "&:hover": {
      color: "#27272A !important",
      background: "transparent",
    },
    "&[data-active]": {
      color: "#27272A !important",
      borderColor: "#27272A",
      "&:hover": {
        borderColor: "#27272A",
      },
    },
  },

  signaturePadParent: {
    position: "relative",
    width: "100%",
    display: "inline-block",
    "& canvas": {
      border: "0.5px solid #CBD5E1",
      width: "100%",
      background: "#fff",
      cursor: "crosshair",
    },
  },
  textPad: {
    height: 160,
    backgroundColor: "#FFF",
    border: "0.5px solid #CBD5E1",
    padding: 10,
    "& input": {
      fontFamily: "'Island Moments', cursive",
      fontSize: 64,
      height: "unset",
      fontWeight: 400,
      color: "#344054",
      textAlign: "center",
    },
  },
  uploadBox: {
    height: 160,
    width: "100%",
    border: "0.5px solid #CBD5E1",
    backgroundColor: "#FFF",
    padding: "0px",
    "& .uploadBoxInner": {
      height: "100%",
      width: "100%",
    },
  },
  previewBox: {
    padding: 10,
    minHeight: 160,
    width: "100%",
    border: "0.5px solid #CBD5E1",
    backgroundColor: "#FFF",
  },
  previewImg: {
    display: "block",
    objectFit: "contain",
    maxHeight: 200,
    width: "auto",
    margin: "auto",
  },
  selectedImgClose: {
    position: "absolute",
    top: 6,
    right: 6,
    borderRadius: "50%",
    backgroundColor: "#27272A",
    paddingLeft: 1,
    paddingBottom: 0.5,
  },
  addSignatureContainer: {
    marginBlock: 50,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      Width: "100%",
  },
}));

export default useStyles;
